import { __makeTemplateObject } from "tslib";
import styled from 'styled-components';
// We use !important to ensure next sibling gets the margin reset no matter what
export var ClearNextSiblingMarginTop = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  & + * {\n    margin-top: 0 !important;\n  }\n"], ["\n  & + * {\n    margin-top: 0 !important;\n  }\n"])));
var templateObject_1;
//# sourceMappingURL=clear-next-sibling-margin-top.js.map